<template>
  <div
    style="border: 0px solid black; width:100%;overflow: auto;display:block;"
  >
    <div
      class="welcome"
      style="border: 0px solid red;display: table; width:100%; "
    >
      <div class="box">
        <div class="box-header">
          <h3 class="box-title">{{ $t("service.service_list") }}</h3>
          <lte-button
            v-if="has_perm('create_service') || GET_ACCOUNT_DATA.id == 1"
            style="float:right;"
            type="btn btn-primary"
            right_icon="glyphicon glyphicon-plus"
            @click="addService($event)"
            >{{ $t("service.service_btn[0]") }}</lte-button
          >
        </div>

        <!-- /.box-header -->
        <div
          class="box-body"
          v-for="service in serviceData"
          :key="service.key"
          :item="service.value"
        >
          <b-button
            class="fix-width"
            v-b-toggle="service.key"
            variant="primary"
            @click="toggleButton(service)"
          >
            {{ $t(service.key) }}
            <span class="set-right">
              <i
                v-bind:class="[
                  service.isCollapsed ? 'fa fa-caret-down' : 'fa fa-caret-right'
                ]"
              ></i>
            </span>
          </b-button>
          <b-collapse
            :id="service.key"
            class="mt-2"
            v-if="has_perm('view_service') || GET_ACCOUNT_DATA.id == 1"
          >
            <b-card>
              <div class="box-body">
                <div class="box-header with-border">
                  <select-option-check
                    v-if="service.key == 'service.service_btn[1]'"
                    style="margin-top:-40px;"
                    :item="columnsPayPerMonth"
                    class="dropdown-trigger"
                    data-icon="eye"
                    @callbackPerMonthData="onSelectColumnPerMonthData"
                  ></select-option-check>
                  <select-option-check
                    v-else-if="service.key == 'service.service_btn[6]'"
                    style="margin-top:-40px;"
                    :item="columnsUncategorized"
                    class="dropdown-trigger"
                    data-icon="eye"
                    @callbackUncategorized="onSelectColumnUncategorized"
                  ></select-option-check>
                </div>
                <lte-table
                  v-if="service.key == 'service.service_btn[1]'"
                  :hdBackground="hdBackground"
                  :data="service.value"
                  :columns="gridColumnsPayPerMonth"
                  search_filter="left-search"
                  @actions="crudActions"
                  :actions="
                    GET_ACCOUNT_DATA.id == 1 ||
                    (has_perm('update_service') && has_perm('delete_service'))
                      ? actions
                      : has_perm('update_service')
                      ? [actions[0]]
                      : has_perm('delete_service')
                      ? [actions[1]]
                      : []
                  "
                  :useFilter="useFilter"
                ></lte-table>
                <lte-table
                  v-else-if="service.key == 'service.service_btn[6]'"
                  :hdBackground="hdBackground"
                  :data="service.value"
                  :columns="gridColumnsUncategorized"
                  search_filter="left-search"
                  @actions="crudActions"
                  :actions="
                    GET_ACCOUNT_DATA.id == 1 ? actions : ['common.modify']
                  "
                  :useFilter="useFilter"
                ></lte-table>
                <lte-table
                  v-else
                  :hdBackground="hdBackground"
                  :data="service.value"
                  :columns="gridColumns"
                  search_filter="left-search"
                  @actions="crudActions"
                  :actions="actions"
                  :useFilter="useFilter"
                ></lte-table>
              </div>
              <!-- Pagination -->
              <div class="box-footer clearfix" style="display:contents;">
                <ul
                  class="pagination pagination-sm no-margin pull-right"
                  v-if="PAGINATOR.length"
                >
                  <li
                    v-bind:disabled="PAGE_ARROW.prev === null"
                    @click="onPrevPagination"
                  >
                    <a>&laquo;</a>
                  </li>
                  <li
                    v-for="(page, index) in PAGINATOR"
                    :key="index"
                    :value="page.value"
                    @click="onPagination(page.value)"
                  >
                    <a>{{ page.text }}</a>
                  </li>
                  <li
                    v-bind:disabled="PAGE_ARROW.next === null"
                    @click="onNextPagination"
                  >
                    <a>&raquo;</a>
                  </li>
                </ul>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <!-- [#1059] - loitt -->
      <lte-modal
        v-show="isModalVisible"
        @onConfirm="onConfirm"
        @close="closeModal"
        v-for="obj in objModal"
        :key="obj.id"
        :item="obj"
      ></lte-modal>

      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import utils from '@/lib/utils';
import LTEModal from "@/components/LTEModal.vue";

export default {
  name: "ServiceList",
  data() {
    return {
      // gridColumns: ["service.name", "service.service_code", "service.category", "service.free",
      // "service.service_provider", "service.service_provider_address",
      // "service.service_type"],
      gridColumns: [
        { text: "service.name", isHidden: true },
        { text: "service.service_code", isHidden: true },
        { text: "service.free", isHidden: true },
        { text: "service.service_price", isHidden: true },
        { text: "service.service_type", isHidden: true }
      ],
      gridColumnsPayPerMonth: [
        { text: "service.name", isHidden: true },
        { text: "service.service_code", isHidden: true },
        { text: "service.free", isHidden: true },
        { text: "service.service_price", isHidden: true },
        { text: "service.service_type", isHidden: true }
      ],
      gridColumnsUncategorized: [
        { text: "service.name", isHidden: true },
        { text: "service.service_code", isHidden: true },
        { text: "service.free", isHidden: true },
        { text: "service.service_price", isHidden: true },
        { text: "service.service_type", isHidden: true }
      ],
      gridColumnsPayPerMonthDefault: [
        { text: "service.name", isHidden: true },
        { text: "service.service_code", isHidden: true },
        { text: "service.free", isHidden: true },
        { text: "service.service_price", isHidden: true },
        { text: "service.service_type", isHidden: true }
      ],
      gridColumnsUncategorizedDefault: [
        { text: "service.name", isHidden: true },
        { text: "service.service_code", isHidden: true },
        { text: "service.free", isHidden: true },
        { text: "service.service_price", isHidden: true },
        { text: "service.service_type", isHidden: true }
      ],
      columnsService: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnsPayPerMonth: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnsUncategorized: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete"],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      tblBorder: "border: 1px solid orange",
      serviceData: {},
      originalData: [],
      isModalVisible: false,
      serviceDataPerMonth: [],
      serviceDataPerTime: [],
      // serviceDataPerHour: [],
      // serviceDataPerSize: [],
      // serviceDataPerQuarter: [],
      serviceDataUncategorized: [],
      collapseOpen: true,
      useFilter: true,

      // [#1059] - [loitt] - Show info confirm modal delete
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ]
    };
  },
  watch: {
    GET_SERVICE_DATA: function() {
      this.serviceData = {};
      this.serviceDataPerMonth = [];
      this.serviceDataPerTime = [];
      this.serviceDataUncategorized = [];
      // this.serviceDataPerHour = [];
      // this.serviceDataPerSize = [];
      // this.serviceDataPerQuarter = [];

      this.GET_SERVICE_DATA.forEach(
        function(service) {
          let id = service.id;
          let name = service.name;
          // let serviceProviderName = service.serviceProviderName;
          //let serviceType = service.serviceTypeId;
          let serviceFeeGroup = service.feeGroupId;
          let serviceTypeName = service.service_type_details.name;
          let serviceCode = service.serviceCode;
          //Temporary close
          //let serviceCategory = service.serviceCategory;
          let serviceFree = null;
          if (service.serviceFree === true) {
            serviceFree = "Yes";
          } else if (service.serviceFree === false) {
            serviceFree = "No";
          } else {
            serviceFree = "";
          }
          // [#1059] - [loitt] fixed issue undefine servicePrice
          let servicePrice = 0;
          if (service.servicePrice.length > 0) {
            servicePrice =
              service.servicePrice[0].fee_value != null
                ? utils.formatNumber(service.servicePrice[0].fee_value)
                : null;
          }
          // let serviceProviderAddress = service.serviceProviderAddress;
          // let date = utils.formatSqlDate(service.dateCreated, null, "dddd, MMMM DD YYYY, h:mm:ss A");
          // this.GET_SERVICE_DATA.forEach(serviceTypeData => {
          //   if (serviceTypeData.id === serviceType) {
          //     serviceTypeName = serviceTypeData.name;
          //   }
          // });

          let data = {
            id: id,
            "service.name": name,
            // 'service.date_created': date,
            "service.service_type": serviceTypeName,
            "service.service_price": servicePrice,
            "service.service_code": serviceCode,
            //Temporary close
            //"service.category": serviceCategory,
            "service.free": serviceFree
          };

          if (serviceFeeGroup === 1) {
            this.serviceDataPerMonth.push(data);
          } else if (serviceFeeGroup === 2) {
            this.serviceDataPerTime.push(data);
            // } else if ( serviceFeeGroup === 3 ) {
            //   this.serviceDataPerHour.push(data);
            // } else if ( serviceFeeGroup === 4 ) {
            //   this.serviceDataPerSize.push(data);
            // } else if ( serviceFeeGroup === 5 ) {
            //   this.serviceDataPerQuarter.push(data);
          } else {
            this.serviceDataUncategorized.push(data);
          }
        }.bind(this)
      );
      this.serviceData = [
        {
          key: "service.service_btn[1]",
          value: this.serviceDataPerMonth,
          isCollapsed: true
        },
        {
          key: "service.service_btn[2]",
          value: this.serviceDataPerTime,
          isCollapsed: true
        },
        // {
        //   key: "service.service_btn[3]",
        //   value: this.serviceDataPerHour,
        //   isCollapsed: true
        // },
        // {
        //   key: "service.service_btn[4]",
        //   value: this.serviceDataPerSize,
        //   isCollapsed: true
        // },
        // {
        //   key: "service.service_btn[5]",
        //   value: this.serviceDataPerQuarter,
        //   isCollapsed: true
        // },
        {
          key: "service.service_btn[6]",
          value: this.serviceDataUncategorized,
          isCollapsed: true
        }
      ];
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (
        this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.params.tablename ==
        "servicelist.paypermonth"
      ) {
        if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
          this.gridColumnsPayPerMonth = this.bindDataColumn();
          this.columnsPayPerMonth.data_list = this.gridColumnsPayPerMonth;
        } else {
          this.gridColumnsPayPerMonth = this.gridColumnsPayPerMonthDefault;
          this.columnsPayPerMonth.data_list = this.gridColumnsPayPerMonth;
        }
      } else if (
        this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.params.tablename ==
        "servicelist.uncategorized"
      ) {
        if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
          this.gridColumnsUncategorized = this.bindDataColumn();
          this.columnsUncategorized.data_list = this.gridColumnsUncategorized;
        } else {
          this.gridColumnsUncategorized = this.gridColumnsUncategorizedDefault;
          this.columnsUncategorized.data_list = this.gridColumnsUncategorized;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_SERVICE_DATA",
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "SERVICE_TYPE_LIST",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  created() {
    this.GET_SERVICE_TYPE_LIST();
  },
  methods: {
    ...mapActions([
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_SERVICE_LIST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_SERVICE_TYPE_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "DELETE_SERVICE"
    ]),

    /**
     * [#1059]
     * author: loitt
     * function: close Modal
     */

    closeModal() {
      this.isModalVisible = false;
    },
    /**
     * [#1059]
     * author: loitt
     * function: confirm delete Modal
     *    1. Delete service
     *    2. Reload service
     */

    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_SERVICE(this.originalRecordData)
        .then(
          function() {
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_SERVICE_LIST(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    bindDataColumn: function() {
      let newGridColumns = [];
      const viewedColumnsKey = Object.keys(
        this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
      );
      const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
        .viewed_columns;
      for (
        let j = 0, sizeOrigin = this.gridColumns.length;
        j < sizeOrigin;
        j++
      ) {
        for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
          if (this.gridColumns[j].text == viewedColumnsKey[i]) {
            let viewdColumnObject = {};
            viewdColumnObject.text = viewedColumnsKey[i];
            viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
            newGridColumns.push(viewdColumnObject);
            break;
          }
        }
      }
      return newGridColumns;
    },
    onSelectColumnPerMonthData: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "servicelist.paypermonth";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSelectColumnUncategorized: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "servicelist.uncategorized";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    toggleButton: function(service) {
      service.isCollapsed = !service.isCollapsed;
    },
    addService: function() {
      this.$router.push({
        name: "ServiceAddEdit",
        params: {
          id: 0
        }
      });
    },

    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "ServiceAddEdit",
          params: {
            id: recordData.id
          }
        });
        // this.SUCCESS_TOAST();
      } else {
        if (this.has_perm("delete_service")) {
          this.originalData = recordData;
          this.isModalVisible = isModalVisible;
        } else {
          alert("Bạn Không Có Quyền Để Xóa");
        }
        // this.SUCCESS_TOAST();
      }
    },

    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_SERVICE_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_SERVICE_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onPagination: function(value) {
      if (value === 0) return false;
      const data = {
        params: {
          page: value
        }
      };
      this.GET_SERVICE_LIST(data);
      this.GET_SERVICE_TYPE_LIST();
    }
  },

  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_SERVICE_LIST(data);
    this.columnsPayPerMonth.data_list = this.gridColumnsPayPerMonth;
    this.columnsUncategorized.data_list = this.gridColumnsUncategorized;
    this.GET_SERVICE_TYPE_LIST();
    const payPerMonthFilter = {
      params: {
        tablename: "servicelist.paypermonth"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(payPerMonthFilter);
    const uncategorized = {
      params: {
        tablename: "servicelist.uncategorized"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(uncategorized);
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    "select-option-check": SelectOptionCheck,
    // [#1059] - [loitt] - add modal delete
    "lte-modal": LTEModal
  }
};
</script>

<style scoped>
.fix-width {
  width: 250px;
}
.set-right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ServiceList.vue